import AnimatedMetrics from '@/components/animatedMetric'
import BusinessModelTabs from '@/components/businessModelTabs'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import Picture from '@/components/picture'
import { ASSET_DIR, metricsList, STRINGS } from '@/constants/businessModel'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const BusinessModel = () => {
  return (
    <LayoutWithNavigation>
      <h1 className="px-6 mb-2.5 max-w-7xl w-full m-auto text-black text-[45px] font-natosans-medium">
        {STRINGS.DEHAAT_NETWORK}
      </h1>
      <Picture
        image={`${ASSET_DIR}/business-model`}
        imageAlt="DeHaat Business Model"
        imageStyle="md:w-1/2 w-full m-auto aspect-[1.312] md:px-0 px-6"
        loading="eager"
      />
      <section className="flex justify-between max-w-7xl w-full m-auto flex-col md:flex-row">
        {metricsList.map(({ heading, value }) => (
          <AnimatedMetrics
            heading={heading}
            value={value}
            containerStyle="md:w-1/5 flex items-center justify-between flex-col"
            key={heading}
          />
        ))}
      </section>
      <section className="max-w-7xl w-full m-auto">
        <BusinessModelTabs />
      </section>
    </LayoutWithNavigation>
  )
}

export default BusinessModel
